<template>
  <div class="yearluck-result-base">
    <form id="send-form" :action="submitPath" method="POST">
      <template v-for="(item, key) in receiveFormData">
        <input
          v-if="key !== 'target_nickname' && key !== 'target_birthday'"
          type="hidden"
          :key="key"
          :name="key"
          :value="item"
        />
      </template>
      <input type="hidden" name="target_nickname" :value="frmTargetNickname" />
      <input type="hidden" name="target_birthday" :value="frmTargetBirthday" />
      <input type="hidden" name="items_id" :value="sendItemId"/>
    </form>

    <!--  <result-header :back-button="true"></result-header> -->
    <yearluck-result-top
      :items-id="itemsId"
      :item-name="itemName"
      :menu-name="menuName"
      :pack-image="packImage"
      :optional-tag-name="optionalTagName"
      :optional-tag-id="optionalTagId"
    ></yearluck-result-top>
    <div class="contents-wrap">
      <user-prof-str
        :user-name="results.nickname"
        :user-birthday="results.birthday"
        :target-nickname="targetNicknameMod"
      ></user-prof-str>

      <article-card-header
        :article-title="resultTitleStr"
        :target-id="targetId"
        :has-voice="hasVoice"
        :voice-data="voiceData"
      />
      <div class="result-document-base">
        <div class="result-document" v-html="resultDocs"></div>
      </div>

      <more-future
        v-if="moreFutureWords.length > 0"
        :more-future-words="moreFutureWords"
        :target-id="targetId"
      ></more-future>

      <div class="counselor-area">
        <h3>監修者紹介</h3>
        <counselor
          :c-name="counselorName"
          :c-prof="counselorProfile"
          :c-image-url="counselorImageUrl"
          :view-type="1"
        ></counselor>
      </div>

      <sns-btns
        :share-line-data="shareLineData"
        :share-twitter-data="shareTwitterData"
      ></sns-btns>

    </div>
<!--
    <other-items
      v-if="otherFortunesMod != null && otherFortunesMod.length > 0"
      :item-list="otherFortunesMod"
      :back-url="backUrl"
      :tgt-birthday="tgtBirthday"
      @onDetailBtnClick="onOtherDetailBtnClick"
    ></other-items>

    <recommend-items
      v-if="recommendItems != null && recommendItems.length > 0"
      :item-list="recommendItems"
    ></recommend-items>

    <div class="back-to-top" v-if="parseInt(itemsId) === 303 || parseInt(itemsId) === 304"><a :href="backUrl">運勢一覧に戻る</a></div>
-->
    <dialog-base :trigger="isDetailDialogOpen" @dialogClose="onDialogClose">
      <purchase-dialog
        :item-data="targetOtherDetailData"
        :target-idx="targetOtherIdx"
        :text-price="otherTextPrice"
        :text-audio-price="otherTextAudioPrice"
        :text-item-id="textItemId"
        :target-birthday-receive="receiveFormData.target_birthday"
        :has-setmenu-recommend="hasSetMenuRecommend"
        :is-set-purchase="isSetPurchase"
        :has-affinity="hasAffinity"
        :back-url="backUrl"
        @submit="onOtherSubmit"
      ></purchase-dialog>
    </dialog-base>

  </div>
</template>

<script>
import YearluckResultTop from '@/utvStore/components/YearLuck/y2020/partials/yearluckResultTop'
import UserProfStr from '@/utvStore/components/YearLuck/y2020/partials/userProfStr'
import ArticleCardHeader from '@/utvStore/components/YearLuck/y2020/partials/articleCardHeader'
import MoreFuture from '@/utvStore/components/YearLuck/y2020/partials/moreFuture'
import SnsBtns from '@/utvStore/components/YearLuck/y2020/partials/snsBtns'
import Counselor from '@/utvStore/components/YearLuck/y2020/partials/counselor'
import RecommendItems from '@/utvStore/components/YearLuck/y2020/partials/recommendItems'
import OtherItems from '@/utvStore/components/YearLuck/y2020/partials/otherItems'
import DialogBase from '@/utvStore/components/YearLuck/y2020/partials/dialogBase'
import PurchaseDialog from '@/utvStore/components/YearLuck/y2020/partials/purchaseDialog'

export default {
  name: 'yearluck2020Result',
  components: {
    MoreFuture,
    SnsBtns,
    YearluckResultTop,
    UserProfStr,
    ArticleCardHeader,
    Counselor,
    RecommendItems,
    OtherItems,
    PurchaseDialog,
    DialogBase,
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      moreFutureWords: '',
      isDetailDialogOpen: false,
      targetOtherDetailData: {},
      targetOtherIdx: -1,
      otherTextPrice: 99,
      otherTextAudioPrice: 150,
      hasSetMenuRecommend: false,
      textItemId: -1,
      sendItemId: -1,
      submitPath: '',
      hasAffinity: false,
      isSetPurchase: false,
      lock: false,
      frmTargetNickname: '',
      frmTargetBirthday: '',
      voiceData: '',
      hasVoice: false
    }
  },
  props: {
    itemsId: String,
    itemName: String,
    menuName: String,
    packImage: String,
    counselorId: String,
    counselorName: String,
    counselorProfile: String,
    counselorImageUrl: String,
    backUrl: String,
    results: {
      type: Object,
      default() {
        return {}
      }
    },
    fortdate: String,
    postData: Object,
    menuList: [Object, Array],
    currentPageNum: {
      type: Number,
      default: 1
    },
    guestId: String,
    optionalTagName: { type: String, default: '' },
    optionalTagId: { type: [Number,String], default: null },
    targetId: {
      type: Number,
      default() {
        return 279
      }
    },
    shareLineData: {
      type: String,
      default() {
        return ''
      }
    },
    shareTwitterData: {
      type: String,
      default() {
        return ''
      }
    },
    otherFortunes: {
      type: Array,
      default() {
        return []
      }
    },
    recommendItems: {
      type: Array,
      default() {
        return []
      }
    },
    isLoggedIn: {
      type: Boolean,
      default() {
        return false
      }
    },
    receiveFormData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {
    this.isLoading = true
    this.setMoreFuture()
    this.checkVoice()
  },
  computed: {
    tgtBirthday() {
      return this.results.target_birthday
    },
    resultTitleStr() {
      return this.results.result_data[0].title || ''
    },
    resultDocs() {
      return this.results.result_data[0].text1 || ''
    },
    itemsIdMod() {
      return parseInt(this.itemsId.substr(3))
    },
    otherFortunesMod() {
      const rtn = []
      for(let item of this.otherFortunes) {
        rtn.push(item)
      }
      return rtn
    },
    targetNicknameMod() {
      if(parseInt(this.itemsId) === 295 || parseInt(this.itemsId) === 296 || this.results.result_data[0].logic_menu_id === 113336 ) {
        return this.results.target_nickname
      } else {
        return ''
      }
    },
  },
  methods: {
    checkVoice() {
      this.voiceData = this.results.voiceUrl
      if(this.voiceData.length > 0 && /.+\.mp3$/.test(this.voiceData)) {
        this.hasVoice = true
      }
    },
    setMoreFuture() {
      const mf = this.$el.querySelector('.more-future p')
      if(mf != null){
        this.moreFutureWords = mf.innerText || ''
      }
    },
    setZeroNumber(num){ // 0埋めをして2けた数字にする
      return ('00' + num).slice(1);
    },
    onDialogClose() {
      this.isDetailDialogOpen = false
      this.lock = false
    },
    onOtherDetailBtnClick(idx) {
      this.targetIdx = idx
      this.targetOtherIdx = idx
      const linkUrl = this.otherFortunesMod[idx].linkUrl

      if(!this.lock) {
        this.lock = true
        if (linkUrl != null && linkUrl.length > 0) {
          location.href = linkUrl
        } else {
          this.targetOtherDetailData = this.otherFortunesMod[idx]
          this.otherTextPrice = this.otherFortunesMod[idx].textItemPrice
          this.otherTextAudioPrice = this.otherFortunesMod[idx].textAudioItemPrice
          this.isSetPurchase = false
          this.hasAffinity = parseInt(this.targetOtherDetailData.textItemId) === 295 || parseInt(this.targetOtherDetailData.textAudioItemId) === 296
          this.textItemId = this.targetOtherDetailData.textItemId
          this.$nextTick(() => {
            this.isDetailDialogOpen = true
          })
        }
      }
    },
    onOtherSubmit(itemtype, idx, isSetPurchase, additionalInfo) {
      // console.log('other submit: %s -- idx:%s', itemtype, idx)
      //現状ここで実際のテキストかオーディオか判定できない
      let itemsId
      switch ( itemtype ) {
        case 't':
          // console.log('表示上はテキストを選択')
          itemsId = this.otherFortunesMod[idx]['textItemId']
          break
        case 'ta':
          // console.log('表示上はテキスト＆オーディオを選択')
          itemsId = this.otherFortunesMod[idx]['textAudioItemId']
          break
      }
      this.sendItemId = itemsId
      this.submitPath = `/special/${ itemsId }/complete`
      // console.log('itemsId: %s action path: %s', itemsId, this.submitPath)
      const frm = document.getElementById('send-form')
      frm.addEventListener('submit', (e) => { })
      if(additionalInfo != null && additionalInfo.hasAffinity){
        //データの整合性チェックする？
        // console.log('追加情報：%O', additionalInfo)
        this.frmTargetNickname = additionalInfo.tgtNickname
        this.frmTargetBirthday = additionalInfo.tgtBirthday
      }
      this.$nextTick(()=>{
        // console.log('----------------------')
        // console.log('Formオブジェクト: %O', frm)
        // console.log('対象アイテム: %O', this.otherFortunesMod[idx])
        // console.log('action path: %s', this.submitPath)
        frm.submit()
      })
      this.isDetailDialogOpen = false

    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../../sass/variables/index';
.yearluck-result-base {
  max-width: 580px;
  margin: 0 auto;
  padding: 0;
  color: $gray-20;
  .contents-wrap {
    padding: 0 25px;
    .result-document-base {
      /deep/ .result-document {
        margin-bottom: 30px;
        img {
          width: 100%;
          display: block;
          margin: 16px auto;

          &.w-half {
            width: 50%;
          }
        }
        .more-future {
          display: none;
        }
        .subtitle1 {
          font-size: 1.2em;
          font-weight: bold;
          margin-top: 20px;
        }
      }
    }
    /deep/ .article-title-header-base {
      margin-bottom: 8px;
    }
    .morefuture-base {
      margin-bottom: 30px;
    }
    .counselor-area {
      border-top: 1px solid $gray-17;
      border-bottom: 1px solid $gray-17;
      padding: 20px 0;
      h3{
        width: 100%;
        color: $brown-10;
        text-align: center;
        margin: 0 0 16px;
      }
    }
  }
  .recommend-items-base {
    padding: 20px 25px;
  }
  .back-to-top {
    width: 100%;
    a {
      display: block;
      width: 100%;
      padding: 12px 8px;
      position: relative;
      background: $brown-10;
      text-align: center;
      color: white;
      font-weight: bold;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
      &:after {
        content: '';
        width: 10px;
        height: 18px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        margin: auto;
        background: url('/static/img/yearluck/y2020/next_white.svg') no-repeat center center;
        background-size: auto 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/yearluck2020Result.vue